import { FileDetailsSection } from "./FileDetailsSection";

/** Default right-rail details — soft card content (shell provides the bubbly frame). */
export function MetaRail() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <h3 className="shrink-0 pb-2.5 text-xl font-normal tracking-tight text-foreground">
        Details
      </h3>
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain py-0.5">
        <FileDetailsSection />
      </div>
    </div>
  );
}
